import React from 'react';

/**
 * Button - Tactical Precision UI Component
 *
 * Variants: primary, secondary, outline, ghost, danger
 * Sizes: sm, md, lg
 * States: default, hover, focus, active, loading, disabled
 *
 * Primary buttons get chamfered corners via CSS clip-path
 */
export const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  fullWidth = false,
  iconOnly = false,
  onClick,
  type = 'button',
  className = '',
  ariaLabel,
  ...props
}) => {
  const baseClass = 'tp-button';
  const variantClass = `tp-button--${variant}`;
  const sizeClass = `tp-button--${size}`;
  const stateClasses = [
    loading && 'tp-button--loading',
    disabled && 'tp-button--disabled',
    fullWidth && 'tp-button--full-width',
    iconOnly && 'tp-button--icon-only'
  ].filter(Boolean).join(' ');

  const handleClick = (e) => {
    if (disabled || loading) {
      e.preventDefault();
      return;
    }
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <button
      type={type}
      className={`${baseClass} ${variantClass} ${sizeClass} ${stateClasses} ${className}`.trim()}
      onClick={handleClick}
      disabled={disabled || loading}
      aria-label={ariaLabel || (iconOnly ? 'Button' : undefined)}
      aria-busy={loading}
      {...props}
    >
      {loading ? (
        <>
          <span className="tp-button__spinner" aria-hidden="true">⏳</span>
          {!iconOnly && <span className="tp-button__text">{children}</span>}
        </>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
